var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigdatachartcon-container"},[(!_vm.nodata)?_vm._t("default"):_c('div',{staticClass:"nopart-con"},[_c('no-data')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }